import { ifscValidationRegex, beneficiaryNameRegex, accountNumberValidationRegex, percentageValidationRegex, amountValidationRegex } from "../app_methods";
import { get, post, put } from "../services/HttpService";

export class SplitAccountModel {

    constructor(splitAccount = {}) {
        this.set(splitAccount);
    };

    static validations = {
        account_number: [
            { required: true, message: "Account number is required." },
            { pattern: accountNumberValidationRegex(), message: "Please enter a valid account number." },
            { min: 1, message: "Must be atlest 1 characters long" },
            { max: 100, message: "Can be of maximum 100 characters" },
        ],
        account_ifsc: [
            { required: true, message: "Account IFSC is required." },
            { pattern: ifscValidationRegex(), message: "Please enter a valid IFSC." },
            { min: 1, message: "Must be atlest 1 characters long" },
            { max: 100, message: "Can be of maximum 100 characters" },
        ],
        account_holder_name: [
            { required: true, message: "Name is required." },
            { pattern: beneficiaryNameRegex(), message: "Please enter a valid name." },
            { min: 1, message: "Must be atlest 1 characters long" },
            { max: 100, message: "Can be of maximum 100 characters" },
        ],
        priority: [
            { required: true, message: "Select Priority" },
            // { pattern: beneficiaryNameRegex(), message: "Please enter a valid name." },
            // { min: 1, message: "Must be atlest 1 characters long" },
            // { max: 100, message: "Can be of maximum 100 characters" },
        ]
    };

    static list = (queryData = {}, config = {}) => {
        return get(`v1/insta-collect/internal/split_accounts/`, queryData, config).catch(
            (error) => ({
              success: false,
              data: (error.response && error.response.data) || {},
              status: (error.response && error.response.status) || 400,
            })
        );
    }

    save = () => {
        let queryData = this.get();
        if (queryData.id) return put(`v1/insta-collect/internal/split_accounts/${this.id}/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
        return post(`v1/insta-collect/internal/split_accounts/`, queryData, {}).catch(error => ({ success: false, data: (error.response && error.response.data) || {}, status: (error.response && error.response.status) || 400 }))
    };

    configure = (queryData = {}, config = {}) => {
        return post(`v1/insta-collect/internal/split_accounts/configure/`, queryData, config).catch((error) => ({
            success: false,
            data: (error.response && error.response.data) || {},
            status: (error.response && error.response.status) || 400,
        }));
    };

    configure_cva = (queryData = {}, config = {}) => {
        
        return post(`v1/insta-collect/internal/split_accounts/custom_virtual_account/${queryData?.cva_id}/configure/`, queryData, config).catch((error) => ({
            success: false,
            data: (error.response && error.response.data) || {},
            status: (error.response && error.response.status) || 400,
        }));
    };

    get = () => {
        return {
            id: this.id,
            account_number: this.account_number,
            account_ifsc: this.account_ifsc,
            account_holder_name: this.account_holder_name
        }
    };

    set = (values) => {
        Object.keys(values).forEach(x => this[x] = values[x]);
    };


}